import { create } from 'zustand'
import { createJSONStorage, persist } from 'zustand/middleware'

/**
 * The picker's preview-only choices — DO Mek and a Custom provider. They change
 * what the picker shows, never the model sent with a chat. `custom` holds the
 * provider, model, and a masked key hint; the key itself is never kept.
 */
export const useMockModelStore = create(
  persist(
    (set) => ({
      choice: null,
      custom: null,
      chooseDoMek: () => set({ choice: 'do-mek' }),
      saveCustom: (custom) => set({ custom, choice: 'custom' }),
      removeCustom: () => set((state) => ({ custom: null, choice: state.choice === 'custom' ? null : state.choice })),
      clearChoice: () => set({ choice: null }),
    }),
    {
      name: 'do-chat-mock-model-v1',
      storage: createJSONStorage(() => localStorage),
      version: 1,
      partialize: ({ choice, custom }) => ({ choice, custom }),
    },
  ),
)
